'use strict'

export default (mockAxios) => {
  mockAxios.onPost(`/mgmt/bcards/delete`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/managementBcardRepositoryMock.js